import { render } from "./SubjectGrade.vue?vue&type=template&id=8b14020a&scoped=true"
import script from "./SubjectGrade.vue?vue&type=script&lang=js"
export * from "./SubjectGrade.vue?vue&type=script&lang=js"

import "./SubjectGrade.vue?vue&type=style&index=0&id=8b14020a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b14020a"]])

export default __exports__